import { useFormik } from "formik";
import * as Yup from "yup";
import { XIcon } from "@heroicons/react/outline";
import { Box, Modal } from "@mui/material";
import { forgetPassword } from '../services/userService';
import { Button, Input, message } from "antd";
import { useState } from "react";

export default function ForgetPasswordModal({ isOpen, setIsOpen }) {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      if (values) {
        try {
          setLoading(true);
          const response = await forgetPassword(values);
          message.success(response.message);
        } catch (error) {
          message.error(error.response.data.message);
        }
      }
      setIsOpen(false);
    },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: window.innerWidth > 768 ? 400 : "90%",
    bgcolor: "#fff",
    border: "1px solid rgba(33, 33, 33, 0.10)",
    boxShadow: 24,
    p: 4,
    color: "#000",
    borderRadius: "10px",
  };

  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)}>
      <Box sx={style}>
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="flex justify-between items-center">
            <span className="font-bold text-xl">Reset Password</span>
            <button type="button" onClick={() => setIsOpen(false)}>
              <XIcon className={`h-6 w-6`} aria-hidden="true" />
            </button>
          </div>
          <div className="flex flex-col gap-2">
            <Input
              id="email"
              type="email"
              {...formik.getFieldProps("email")}
              className="w-full p-2 border font-InterTight text-[14px] rounded text-black "
              placeholder="Enter your email"
              style={{
                borderColor:
                  formik.touched.email && formik.errors.email ? "red" : "gray",
              }}
            />
            {formik.touched.email && formik.errors.email ? (
              <div style={{ color: "red" }}>{formik.errors.email}</div>
            ) : null}
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className="bg-[#E61F26] h-[45px] w-full" 
            loading={loading}                     
          >
            Send Verification Link
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
